var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2037_1283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 124,
    r: 124,
    fill: "#100E0E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 124,
    r: 120.5,
    stroke: "#004225",
    strokeWidth: 7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2461 163.615C105.696 163.615 110.813 160.992 114.597 155.746C118.381 150.5 120.832 144.136 121.95 136.654H129.948C128.744 145.942 125.691 153.854 120.789 160.39C118.037 164.002 114.898 166.711 111.372 168.517C107.932 170.237 104.105 171.355 99.8911 171.871C95.7631 172.387 90.3451 172.645 83.6371 172.645C74.1771 172.645 66.4801 171.742 60.5461 169.936C54.6981 168.044 49.6671 164.991 45.4531 160.777C37.1971 152.521 33.0691 141.169 33.0691 126.721C33.0691 111.499 36.7671 100.19 44.1631 92.794C48.9791 87.978 54.3541 84.796 60.2881 83.248C66.2221 81.7 74.0051 80.926 83.6371 80.926C92.4951 80.926 99.6761 81.571 105.18 82.861C110.77 84.065 115.328 86.688 118.854 90.73C121.778 94.084 124.057 98.126 125.691 102.856C127.325 107.586 128.271 112.273 128.529 116.917H121.176C120.832 113.047 119.886 109.091 118.338 105.049C116.876 100.921 114.554 97.395 111.372 94.471C108.19 91.461 104.148 89.956 99.2461 89.956C94.6021 89.956 90.8611 91.977 88.0231 96.019C85.5291 99.201 83.6371 103.888 82.3471 110.08C81.4011 114.81 80.9281 120.357 80.9281 126.721C80.9281 136.783 82.1321 144.91 84.5401 151.102C87.6361 159.444 92.5381 163.615 99.2461 163.615ZM109.154 126.721C109.154 111.499 112.895 100.19 120.377 92.794C125.193 87.978 130.568 84.796 136.502 83.248C142.436 81.7 150.219 80.926 159.851 80.926C168.795 80.926 175.976 81.571 181.394 82.861C186.898 84.065 191.413 86.688 194.939 90.73C197.863 94.084 200.142 98.169 201.776 102.985C203.496 107.715 204.485 112.359 204.743 116.917H197.39C197.046 113.047 196.1 109.091 194.552 105.049C193.09 100.921 190.768 97.395 187.586 94.471C184.404 91.461 180.362 89.956 175.46 89.956C170.902 89.956 167.118 91.977 164.108 96.019C161.528 99.545 159.679 104.232 158.561 110.08C157.529 115.24 157.013 120.787 157.013 126.721C157.013 136.439 158.217 144.566 160.625 151.102C163.807 159.444 168.752 163.615 175.46 163.615V127.882H214.934V172C202.55 172 188.532 172.172 172.88 172.516L159.851 172.645C150.391 172.645 142.694 171.742 136.76 169.936C130.912 168.044 125.881 164.991 121.667 160.777C113.325 152.435 109.154 141.083 109.154 126.721Z",
    fill: "#F6F3E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2037_1283",
    x: 0,
    y: 0,
    width: 249.3,
    height: 249.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2037_1283"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2037_1283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2037_1283",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.20e651da5f0e618580ed80ecd03a51b5.svg";
export { ForwardRef as ReactComponent };